import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import BatchDetail from "@/pages/BatchDetail";
import Employees from "@/pages/Employees";
import Contracts from "@/pages/Contracts";
import HistoryPage from "@/pages/History";
import SettingsPage from "@/pages/Settings";
import Deadlines from "@/pages/Deadlines";
import Documents from "@/pages/Documents";
import Imports from "@/pages/Imports";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="grid min-h-screen place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/registrazione" element={<Register />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reimposta-password" element={<ResetPassword />} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="cedolini" element={<Upload />} />
            <Route path="cedolini/:id" element={<BatchDetail />} />
            <Route path="cedolini/storico" element={<HistoryPage />} />
            <Route path="buste-paga" element={<Navigate to="/cedolini" replace />} />
            <Route path="storico" element={<Navigate to="/cedolini/storico" replace />} />
            <Route path="dipendenti" element={<Employees />} />
            <Route path="contratti" element={<Contracts />} />
            <Route path="scadenze" element={<Deadlines />} />
            <Route path="documenti" element={<Documents />} />
            <Route path="importazioni" element={<Imports />} />
            <Route path="impostazioni" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
